export const INITIAL_DATE = 0;
// Pension licenses cases
export const SUSPENSION_LICENSE_ID = '64D1EE3E-EAFF-418D-BD89-EB95BC08EB41';
export const LICENSE_NR = '78EB9D57-C8D3-416D-A331-4ECD20FFA32B';
export const INJUSTIFIED_ABSENCE_ID = 'C56DCBA0-D885-47D8-95B0-AF4F785D7D78';
export const PAYSLIP_VALID_ABSNCE_IDS = [SUSPENSION_LICENSE_ID, LICENSE_NR, INJUSTIFIED_ABSENCE_ID];
